export default {
  errorDefault: 'Ein Fehler ist aufgetreten',
  unknown: 'Unbekannt',
};
